export enum PaymentMethodStatus {
    ACTIVE = 1,          // activo
    BLACK_LIST = 2,      // lista negra
    TEMPORAL_BLOCK = 3,  // bloqueo temporal
}